export const imagePathFormat = (imgUrl) => {
    return `${process.env.PUBLIC_URL}${imgUrl}`
}